import checkpointOneUrl from '@/assets/1-checkpoint.webp';
import checkpointTwoUrl from '@/assets/2-checkpoint.webp';
import checkpointThreeUrl from '@/assets/3-checkpoint.webp';
import checkpointFourUrl from '@/assets/4-checkpoint.webp';
import platformLogoUrl from '@/assets/bar-chess-manager-logo.webp';
import teamOneIllustrationUrl from '@/assets/team1-illustration.webp';
import teamTwoIllustrationUrl from '@/assets/team2-illustration.webp';
import teamThreeIllustrationUrl from '@/assets/team3-illustration.webp';

export const publicClubCtaItems = [
  'registration',
  'pairings',
  'standings',
  'ratings',
  'seasons',
  'support',
];

export const aboutProjectTimelineItems = [
  {
    number: '01',
    translationKey: 'idea',
    icon: checkpointOneUrl,
  },
  {
    number: '02',
    translationKey: 'firstTournaments',
    icon: checkpointTwoUrl,
  },
  {
    number: '03',
    translationKey: 'firstVersion',
    icon: checkpointThreeUrl,
  },
  {
    number: '04',
    translationKey: 'development',
    icon: checkpointFourUrl,
  },
  {
    number: '05',
    translationKey: 'publicLaunch',
    icon: platformLogoUrl,
  },
];

export const aboutTeamItems = [
  {
    translationKey: 'organizers',
    image: teamOneIllustrationUrl,
  },
  {
    translationKey: 'developers',
    image: teamTwoIllustrationUrl,
  },
  {
    translationKey: 'community',
    image: teamThreeIllustrationUrl,
  },
];
